/**
 * @fileoverview Linked Account Task for Yelp in the Enterprise Launch Flow.
 *
 * @author Wais Shahbaz (wshahbaz@yext.com)
 */

import {YelpConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/yelpconfiguration';
import {YelpLinkedAccount} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/yelp/yelplinkedaccount';
import {EnterpriseConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/enterpriseconfiguration';
import {Task} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/task';
import {TaskIds} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/taskids';

import YelpLogoLargeSvg from '/src/com/yext/listingslaunchstorm/public/icons/yelp-logo-large.svg';
import YelpLogoSvg from '/src/com/yext/listingslaunchstorm/public/icons/yelp-logo.svg';

/**
 * @param {number} publisherId
 */
export const YelpLinkedAccountTask = publisherId => new Task({
  id: TaskIds.YELP_LINKED_ACCOUNT,

  getCard: (_enterpriseConfiguration, _index, selectedPageId, setSelectedPageId, disabled) => ({
    id: TaskIds.YELP_LINKED_ACCOUNT,
    title: yext.msg('Linked Accounts'),
    icon: <YelpLogoSvg />,
    isSelected: TaskIds.YELP_LINKED_ACCOUNT === selectedPageId,
    onClick: disabled ? undefined : () => setSelectedPageId(TaskIds.YELP_LINKED_ACCOUNT),
  }),

  getPage: (enterpriseConfiguration, setEnterpriseConfiguration, _pageControls) => ({
    id: TaskIds.YELP_LINKED_ACCOUNT,
    layoutHeader: {
      icon: <YelpLogoLargeSvg/>,
      title: yext.msg('Yelp'),
      description: yext.msg('Link your Yelp account. Your account will remain linked and can be found in Account Settings.'),
    },
    content: <YelpLinkedAccount
      publisherId={publisherId}
      yelpConfiguration={enterpriseConfiguration.yelpConfiguration ?? YelpConfiguration.empty()}
      setYelpConfiguration={yelpConfiguration => setEnterpriseConfiguration(
        new EnterpriseConfiguration({...enterpriseConfiguration, yelpConfiguration}),
      )}
    />,
  }),

  isComplete: enterpriseConfiguration => (
    isConfigurationComplete(enterpriseConfiguration.yelpConfiguration)),
  isSectionSkipped: enterpriseConfiguration => enterpriseConfiguration?.yelpConfiguration?.skipSetup === true,
});

function isConfigurationComplete(yelpConfiguration) {
  return !!yelpConfiguration?.linkedAccount || yelpConfiguration?.skipSetup;
}
